import React from 'react';
import { motion } from 'framer-motion';
interface RadiantStarProps {
  size?: number;
  className?: string;
  animate?: boolean;
  delay?: number;
}
export function RadiantStar({
  size = 64,
  className = '',
  animate = true,
  delay = 0
}: RadiantStarProps) {
  return <motion.div className={`relative flex items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} initial={animate ? {
    opacity: 0,
    scale: 0.8
  } : undefined} animate={animate ? {
    opacity: 1,
    scale: 1
  } : undefined} transition={{
    duration: 1.5,
    delay: delay,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-139">
      {/* Glow effect behind */}
      <div className="absolute inset-0 bg-gold-400/20 blur-xl rounded-full" style={{
      transform: 'scale(1.5)'
    }} data-id="element-140" />

      {/* Main Star SVG */}
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full relative z-10 drop-shadow-[0_0_15px_rgba(255,255,255,0.5)]" data-id="element-141">
        {/* Center Glow */}
        <circle cx="50" cy="50" r="8" fill="url(#centerGlow)" data-id="element-142" />

        {/* Vertical Beam */}
        <path d="M50 0 L53 45 L50 50 L47 45 L50 0Z" fill="url(#beamGradient)" data-id="element-143" />
        <path d="M50 100 L47 55 L50 50 L53 55 L50 100Z" fill="url(#beamGradient)" data-id="element-144" />

        {/* Horizontal Beam */}
        <path d="M0 50 L45 47 L50 50 L45 53 L0 50Z" fill="url(#beamGradient)" data-id="element-145" />
        <path d="M100 50 L55 53 L50 50 L55 47 L100 50Z" fill="url(#beamGradient)" data-id="element-146" />

        {/* Diagonal Beams (Smaller) */}
        <path d="M20 20 L45 45 L50 50 L45 45 L20 20Z" fill="url(#beamGradientSoft)" opacity="0.6" data-id="element-147" />
        <path d="M80 20 L55 45 L50 50 L55 45 L80 20Z" fill="url(#beamGradientSoft)" opacity="0.6" data-id="element-148" />
        <path d="M80 80 L55 55 L50 50 L55 55 L80 80Z" fill="url(#beamGradientSoft)" opacity="0.6" data-id="element-149" />
        <path d="M20 80 L45 55 L50 50 L45 55 L20 80Z" fill="url(#beamGradientSoft)" opacity="0.6" data-id="element-150" />

        {/* Center Core Brightness */}
        <circle cx="50" cy="50" r="3" fill="white" data-id="element-151" />

        <defs data-id="element-152">
          <radialGradient id="centerGlow" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(50 50) rotate(90) scale(25)" data-id="element-153">
            <stop stopColor="white" data-id="element-154" />
            <stop offset="0.4" stopColor="#F4C430" data-id="element-155" /> {/* Gold-400 approx */}
            <stop offset="1" stopColor="#F4C430" stopOpacity="0" data-id="element-156" />
          </radialGradient>

          <linearGradient id="beamGradient" x1="50" y1="0" x2="50" y2="50" gradientUnits="userSpaceOnUse" data-id="element-157">
            <stop stopColor="white" stopOpacity="0" data-id="element-158" />
            <stop offset="0.5" stopColor="white" stopOpacity="0.8" data-id="element-159" />
            <stop offset="1" stopColor="white" data-id="element-160" />
          </linearGradient>

          <linearGradient id="beamGradientSoft" x1="20" y1="20" x2="50" y2="50" gradientUnits="userSpaceOnUse" data-id="element-161">
            <stop stopColor="#F4C430" stopOpacity="0" data-id="element-162" />
            <stop offset="1" stopColor="white" stopOpacity="0.8" data-id="element-163" />
          </linearGradient>
        </defs>
      </svg>

      {/* Subtle pulsing animation for life */}
      {animate && <motion.div className="absolute inset-0 bg-white/10 blur-2xl rounded-full" animate={{
      opacity: [0.3, 0.6, 0.3],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-164" />}
    </motion.div>;
}